import { RouteRecordRaw } from 'vue-router'

import SelectFile from '@/popup/components/views/Home/RestoreProfiles/SelectFile.vue'
import ConfirmSingle from '@/popup/components/views/Home/RestoreProfiles/ConfirmSingle.vue'
import ConfirmMultiple from '@/popup/components/views/Home/RestoreProfiles/ConfirmMultiple.vue'

const restoreRoutes: Array<RouteRecordRaw> = [
  {
    path: '/restore/select-backup-file',
    name: 'select-backup-file',
    component: SelectFile,
  },
  {
    path: '/restore/confirm-single',
    name: 'confirm-single',
    component: ConfirmSingle,
  },
  {
    path: '/restore/confirm-multiple',
    name: 'confirm-multiple',
    component: ConfirmMultiple,
  },
]

export default restoreRoutes
